import albertaList from '../data/alberta.json';
import canadaList from '../data/canada.json';
import intlList from '../data/international.json';
import Swal from 'sweetalert2';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import AxiosConfig from '../api/axios.config';

interface ApplyModel {
    aboutMeText: String,
    offeredText: String,
    schoolLocationText: String,
    startDateText: String,
    totalCheckBoxes: Array<String>,
    checkedBoxes: Array<String>,
    dataList: Array<any>
}

class Apply {
    dataList: any;
    profile : Storage;
    axiosClient: AxiosInstance;

    headerText : string;
    bodyCopy : string;

    percentageCircle : HTMLElement;
    percentageNumber : HTMLElement;
    completedIcon : HTMLElement;

    schoolLocationInput : HTMLSelectElement;
    aboutMeInput : HTMLSelectElement;
    offeredInput : HTMLSelectElement;
    startDateInput : HTMLSelectElement;

    schoolLocationStorage : string;
    schoolLocationTextStorage : string;
    aboutMeStorage : string;
    offeredStorage : string;
    startDateStorage : string;
    currentStepStorage : number;

    checkBoxes : NodeListOf<HTMLInputElement>;

    timelineSections :  NodeListOf<Element>;
    timelineFill : HTMLElement;

    formGroup : NodeListOf<Element>;

    nextStepBtn : HTMLAnchorElement;
    goBackBtn : HTMLAnchorElement;
    resetBtn : HTMLAnchorElement;
    downloadBtn: HTMLAnchorElement;

    currentStep : number;

    constructor()
    {
        this.axiosClient = axios.create(AxiosConfig);
        this.init();
    }

    init()
    {
        const self = this;
        self.profile = localStorage;

        self.schoolLocationInput = document.querySelector('select#schoolLocation');
        self.aboutMeInput =  document.querySelector('select#aboutMe');
        self.offeredInput =  document.querySelector('select#offered');
        self.startDateInput =  document.querySelector('select#startDate');

        self.schoolLocationStorage = self.profile.getItem('schoolLocationValue');
        self.schoolLocationTextStorage = self.profile.getItem('schoolLocationText');
        self.aboutMeStorage = self.profile.getItem('aboutMeValue');
        self.offeredStorage = self.profile.getItem('offeredValue');
        self.startDateStorage = self.profile.getItem('startDateValue');
        self.currentStepStorage = parseInt(self.profile.getItem('currentStep'));
        
        self.timelineSections = document.querySelectorAll('.cl-timeline .tl-section');
        self.timelineFill = document.querySelector('.completed-tl');

        self.formGroup = document.querySelectorAll('.step-group');

        self.nextStepBtn = document.querySelector('#nextStep');
        self.goBackBtn = document.querySelector('#returnBtn');
        self.resetBtn = document.querySelector('#resetBtn');
        self.downloadBtn = document.querySelector('#downloadBtn');
        self.currentStep = 1;

        self.checkBoxes = document.querySelectorAll('.form-check input');

        //update local storage when select options are changed (Location, About Me, etc)
        self.schoolLocationInput.addEventListener('change', (e) => {
            const location = self.schoolLocationInput.value;
            let locationText;
            
            if (location != null) {
                locationText = self.schoolLocationInput.querySelector('option:checked').textContent;

                //set localStorage
                localStorage.setItem('schoolLocationValue', location);
                localStorage.setItem('schoolLocationText', locationText);

                //reset checkedboxes 
                localStorage.removeItem("checkedBoxes");
                self.showCheckBoxes();
                self.updateProgress();
    
                //update other dropdown options
                self.updateAboutMeOptions(location);
                self.nextStepBtn.classList.add('disabled');

            }
        })

        self.aboutMeInput.addEventListener('change', (e) => {
            const aboutMe = self.aboutMeInput.value;
            let aboutMeText;

            if (aboutMe != null) {
                aboutMeText = self.aboutMeInput.querySelector('option:checked').textContent;

                //set localStorage
                localStorage.setItem('aboutMeValue', aboutMe);
                localStorage.setItem('aboutMeText', aboutMeText);

                //reset checkedboxes 
                localStorage.removeItem("checkedBoxes");
                self.showCheckBoxes();
                self.updateProgress();

                //enable next field
                self.offeredInput.disabled = false;

                if(self.offeredInput.querySelector('option:checked') != null && self.startDateInput.querySelector('option:checked') != null){
                    self.nextStepBtn.classList.remove('disabled');
                    self.enableTimeline()
                }

              
            }          
        })

        self.offeredInput.addEventListener('change', (e) => {
            const offered = self.offeredInput.value;
            let offeredText;

            if (offered != null) {
                offeredText = self.offeredInput.querySelector('option:checked').textContent;

                //set localStorage
                localStorage.setItem('offeredValue', offered);
                localStorage.setItem('offeredText', offeredText);

                //enable next field
                self.startDateInput.disabled = false;
            }          
        })

        self.startDateInput.addEventListener('change', e => {
            const startDate = self.startDateInput.value;
            let startDateText;

            if (startDate != null) {
                startDateText = self.startDateInput.querySelector('option:checked').textContent;

                //set localStorage
                localStorage.setItem('startDateValue', startDate);
                localStorage.setItem('startDateText', startDateText);

                //enable button and timeline
                self.nextStepBtn.classList.remove('disabled');
                self.enableTimeline()
            }    
        })
        
        //update local storage when checkboxes are changed
        document.addEventListener('change', (e) => {
            const thisTarget = e.target as HTMLInputElement;
            if((thisTarget) && thisTarget.getAttribute('type') === 'checkbox' ) {
                if(thisTarget.checked){
                    self.addToCheckBoxStorage(thisTarget.id);
                } else {
                    self.removeFromCheckBoxStorage(thisTarget.id);
                }
                self.updateProgress();
            }
        })

        if(self.schoolLocationStorage){
            //highlight Location option if exists in Localstorage
            self.selectElement('schoolLocation', self.schoolLocationStorage);
            self.updateAboutMeOptions(self.schoolLocationStorage);
        }

        if(self.aboutMeStorage){
            //highlight About Me option if exists in Localstorage
            self.selectElement('aboutMe', self.aboutMeStorage);
            self.offeredInput.disabled = false;
        }

        if(self.offeredStorage){
            //highlight Offered option if exists in Localstorage
            self.selectElement('offered', self.offeredStorage);
            self.startDateInput.disabled = false;
        }

        if(self.startDateStorage){
            //highlight Start date option if exists in Localstorage, then enable timeline
            self.selectElement('startDate', self.startDateStorage);
            self.nextStepBtn.classList.remove('disabled');
            self.enableTimeline()
        }

        //update timeline
        self.timelineSections.forEach(section => {
            const thisNumber = parseInt(section.id.split('-').pop());
            section.addEventListener('click', () => {
                self.currentStep = thisNumber;
                self.checkCurrentStep()
            })
        })

        //update currentStep on button click
        self.nextStepBtn.addEventListener('click', () => {
            self.currentStep++;
            self.checkCurrentStep();
        })

        self.goBackBtn.addEventListener('click', () => {
            self.currentStep--;
            self.checkCurrentStep();
        })

        self.resetBtn.addEventListener('click', () => {
            self.currentStep = 1;

            //reset localstorage
            localStorage.removeItem("schoolLocationValue");
            localStorage.removeItem("schoolLocationText");
            localStorage.removeItem("aboutMeValue");
            localStorage.removeItem("aboutMeText");
            localStorage.removeItem("offeredValue");
            localStorage.removeItem("offeredText");
            localStorage.removeItem("startDateText");
            localStorage.removeItem("startDateValue");
            localStorage.removeItem("totalCheckBoxes");

            //reset form
            self.schoolLocationInput.value = "Select an option";
            self.aboutMeInput.value = "Select an option";
            self.offeredInput.value = "Select an option";
            self.startDateInput.value = "Select an option";

            //disable form
            self.aboutMeInput.disabled = true;
            self.offeredInput.disabled = true;
            self.startDateInput.disabled = true;

            //disable timeline
            self.disableTimeline();

            //disable btn
            self.nextStepBtn.classList.add('disabled');

            //reset checkedboxes 
            localStorage.removeItem("checkedBoxes");
            self.showCheckBoxes();
            self.updateProgress();
            self.checkCurrentStep();

            this.completedIcon.classList.remove('active');
            this.percentageNumber.classList.remove('deactive');

            this.hideDownloadBtn();
        });

        self.downloadBtn.addEventListener('click', () => {
            // console.log("pdf download");
            let applyModel = {
                aboutMeText: localStorage.getItem("aboutMeText") as String,
                offeredText: localStorage.getItem("offeredText") as String,
                schoolLocationText: localStorage.getItem("schoolLocationText") as String,
                startDateText: localStorage.getItem("startDateText") as String,
                totalCheckBoxes: JSON.parse(localStorage.getItem("totalCheckBoxes")) as Array<String>,
                checkedBoxes: JSON.parse(localStorage.getItem("checkedBoxes")) as Array<String>,
                dataList: this.dataList
            } as ApplyModel;

            Swal.fire({
                title: '<strong>Creating PDF...</strong>',
                icon: 'info',
                html:
                  'Please wait!',
                showCloseButton: false,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false,
                allowOutsideClick: false
            });

            // Swal.fire({
            //     title: '<strong>Temporarily disabled</strong>',
            //     icon: 'info',
            //     html:
            //       'Please check back soon.',
            //     showCloseButton: true,
            //     showCancelButton: false,
            //     showConfirmButton: false,
            //     focusConfirm: false,
            //     allowOutsideClick: true
            // });
            // console.log(applyModel);
            self.axiosClient.post('/api/pdf/checklist', applyModel, {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                }
              })
              .then(function (response) {
                Swal.close();
                const link = document.createElement('a');
                link.style.display = 'none';
                document.body.appendChild(link);
                const blob = new Blob([ response.data ], {type: 'application/pdf'});
                link.href = URL.createObjectURL(blob);
                link.target = "_blank";
                link.download =  'how-to-apply-checklist.pdf';
                link.click();
              })
              .catch(function (error) {
                Swal.close();
                // console.log(error);
            });
        });

        //window.onload = function() {//
        self.showCheckBoxes();
        self.updateCheckBoxes();
        self.updateProgress();
        //}
    }

    checkCurrentStep() {
        //update all things when currentStep is changed
        if (this.currentStep === 1){
            this.goBackBtn.classList.add('d-none');
            this.nextStepBtn.classList.remove('d-none');
            this.nextStepBtn.innerHTML = "Start Journey <ion-icon name=\"chevron-forward\"></ion-icon>";
        }
        if (this.currentStep > 1){
            this.goBackBtn.classList.remove('d-none');
            this.nextStepBtn.classList.remove('d-none');
            this.nextStepBtn.innerHTML = "Next Step <ion-icon name=\"chevron-forward\"></ion-icon>";
        } 
        if(this.currentStep === 4){
            this.nextStepBtn.classList.add('d-none');
        }

        localStorage.setItem('currentStep', this.currentStep.toString());

        this.updateContentCopy(this.currentStep);
        this.updateTimeline(this.currentStep);
        this.showCurrentStep(this.currentStep);
        this.updateCheckBoxes();
        this.updateProgress();
    }
    
    

    showCurrentStep(step){
        this.formGroup.forEach(group => {
            const thisGroupNumber = parseInt(group.id.split('-').pop()); 
            if(step === thisGroupNumber){
                group.classList.add('active');
            } else {
                group.classList.remove('active');
            }
        })
    }

    updateContentCopy(step){
        const headerElement = document.querySelector('.cl-content h2');
        const bodyElement = document.querySelector('.cl-content #checklistIntro');
        switch(step){
            case 1:
                this.headerText = "Start your journey";
                this.bodyCopy = "The steps you go through when applying to SAIT depend on a number of factors. This interactive tool will make the SAIT application process clear, simple and straightforward while providing you with the information you need to in order to apply.";
                break;
            case 2: 
                this.headerText = "Before You Apply";
                this.bodyCopy = "There are a few things you need to know before you begin. Make sure you're aware of your program's application and admission timelines as well as when your program starts — you'll be asked to select a term when you fill out the online application.";
                break;
            case 3: 
                this.headerText = "When You Apply";
                this.bodyCopy = "When you start your application, you'll be directed to ApplyAlberta - a centralized online system used by most Alberta post-secondary schools. You'll create a MyAlberta Digital ID account, where you will need to take note of your login information.";
                break;
            case 4: 
                this.headerText = "After you Apply";
                this.bodyCopy = "Within a week, you will receive an email acknowledging that SAIT has received your application. The email will include your SAIT ID number and instructions on how to login to mySAIT.ca and monitor your application status. Make sure you notify the Office of the Registrar if your email address changes.";
                break;
        }

        headerElement.textContent = this.headerText;
        bodyElement.textContent = this.bodyCopy;
    }

    showCheckBoxes(){
        const formGroupWrap = document.querySelectorAll('.step-group .custom-form-group');
        const updatedLocationValue = parseInt(localStorage.getItem('schoolLocationValue'));
        const updatedaboutMeValue = localStorage.getItem('aboutMeValue');
        let dataList;
        
        //get right file depending on location
        switch(updatedLocationValue){
            case 1:
                this.dataList = albertaList;
                dataList = albertaList
                break;
            case 2:
                this.dataList = canadaList;
                dataList = canadaList
                break;
            case 3:
                this.dataList = intlList;
                dataList = intlList
                break;
        }

        //formGroupWrap.innerHTML = '';
        formGroupWrap.forEach(group => {
            if(group.parentElement.id != "stepGroup-1"){
                group.innerHTML = '';
            }
        })

        if(dataList != null){
            this.formGroup.forEach(wrap => {
                const formWrap = wrap.querySelector('.custom-form-group');
                const wrapID = wrap.id;
                let content;
                //console.log(dataList);
                const groupStepNumber = wrapID.slice(wrapID.length - 1);
    
                switch(groupStepNumber){
                    case "2":
                        content = dataList.s1
                        break;
                    case "3":
                        content = dataList.s2
                        break;
                    case "4":
                        content = dataList.s3
                        break; 
                }
    
                if (wrapID != "1"){
                    for (const group in content) {
                        //get checkboxes from default and associated audience (aboutMeValue in local storage)
                        //0 = default checkboxes visible for every option
                        if(group === "0" || group === updatedaboutMeValue){
                            content[0][group].forEach(item => {
                                this.renderCheckBoxes(item["name"], item["url"], formWrap);
                            });
                        }
                    }
                }
                
            })

        }

    }

    showDownloadBtn(){
        this.downloadBtn.classList.add('active');
    }

    hideDownloadBtn(){
        this.downloadBtn.classList.remove('active');
    }

    renderCheckBoxes(name, url, parentDiv){
        let totalCheckBoxes = JSON.parse(localStorage.getItem("totalCheckBoxes"));
        let boxID = name.replace(/[^\w\s]/gi, ''); 
        boxID = boxID.replace(/\s+/g, '');
        let checkWrapper = document.createElement('div');
        let newCheckBox = document.createElement('input');
        let newLabel = document.createElement('label');
        let newLink = document.createElement('a');
        let newIcon = document.createElement('ion-icon');
        checkWrapper.classList.add('form-check');
        newIcon.setAttribute('name', 'open-outline');
        newLink.setAttribute('href', url);
        newLink.setAttribute('title', 'Get more information about this step');
        newLink.appendChild(newIcon);
        newCheckBox.setAttribute('type', 'checkbox');
        newCheckBox.classList.add('form-check-input', 'form-custom-checkbox');
        newCheckBox.id = boxID;
        newLabel.setAttribute('for', boxID);
        newLabel.textContent = name;
        checkWrapper.appendChild(newCheckBox);
        checkWrapper.appendChild(newLabel);
        if(url != "#"){
            checkWrapper.appendChild(newLink);
        }        
        parentDiv.appendChild(checkWrapper);

        //TODO: get application progress to work on page load
        if(totalCheckBoxes == null) totalCheckBoxes = [];
        totalCheckBoxes.push(boxID);
        //add back to localstorage
        localStorage.setItem("totalCheckBoxes", JSON.stringify(totalCheckBoxes));
    }

    addToCheckBoxStorage(name){
        let checkedBoxes = JSON.parse(localStorage.getItem("checkedBoxes"));
        if(checkedBoxes == null) checkedBoxes = [];
        checkedBoxes.push(name);
        //add back to localstorage
        localStorage.setItem("checkedBoxes", JSON.stringify(checkedBoxes));
        if(checkedBoxes.length > 0){
            this.showDownloadBtn();
        }
    }

    removeFromCheckBoxStorage(name){
        let checkedBoxes = JSON.parse(localStorage.getItem("checkedBoxes"));
        if(checkedBoxes == null) checkedBoxes = [];
        const thisIndex = checkedBoxes.indexOf(name);
        //remove instances of unchecked box
        if(thisIndex > -1){
            checkedBoxes = checkedBoxes.filter(i => i !== name);
        }
        localStorage.setItem("checkedBoxes", JSON.stringify(checkedBoxes));
        if(checkedBoxes.length === 0){
            this.hideDownloadBtn();
        }
    }

    updateCheckBoxes(){
        let checkedBoxes = JSON.parse(localStorage.getItem("checkedBoxes"));
        if(checkedBoxes != null){
            if(checkedBoxes.length){
                checkedBoxes.forEach(name => {
                    const thisBox = document.querySelector('input#'+name) as HTMLInputElement;
                    if(thisBox != null){
                        thisBox.checked = true;
                    }
                });
            }
        }
    }

    updateTimeline(step){
        this.timelineSections.forEach(section => {
            section.classList.remove('active');
            section.classList.remove('completed')
            const secNumber = parseInt(section.id.split('-').pop());
            if(secNumber === step){
                section.classList.add('active');
            } else if(secNumber < step){
                section.classList.add('completed');
            }
        })
        switch(step){
            case 1: 
                this.timelineFill.classList.remove('first', 'second', 'third');
                break;
            case 2:
                this.timelineFill.classList.remove('second', 'third');
                this.timelineFill.classList.add('first');
                break;
            case 3:
                this.timelineFill.classList.remove('first', 'third');
                this.timelineFill.classList.add('second');
                break;
            case 4:
                this.timelineFill.classList.remove('first', 'second');
                this.timelineFill.classList.add('third');
                break;
        }
    }

    enableTimeline(){
        this.timelineSections.forEach(section => {
            section.classList.remove('disabled');
        })
       
    }

    disableTimeline(){
        this.timelineSections.forEach(section => {
            if(section.id != "step-1"){
                section.classList.add('disabled');
            }
        })
    }

    selectElement(id, valueToSelect){
        let element : HTMLSelectElement = document.querySelector('#'+id);
        element.value = valueToSelect;
    }

    updateAboutMeOptions(locationValue){
        //update options based on location field selection
        let aboutMeOptions : Object;
        if (locationValue === "1" || locationValue === "2") {
            aboutMeOptions = {
                "Select an option": null,
                "I am currently in high school": "1",
                "I am upgrading or planning to upgrade": "2",
                "I've been out of high school for a while": "3",
                "I've completed a post-secondary course or program": "4"
            };
        } else if (locationValue === "3") {
            aboutMeOptions = {
                "Select an option": null,
                "I am an international student": "5",
                "I am a permanent resident or Canadian citizen": "6",
            };
        }
        //clear options then add new ones
        this.aboutMeInput.innerHTML = ''; 
        for (const key in aboutMeOptions){
            const optionElement = document.createElement('option');
            optionElement.innerText = key;
            if(aboutMeOptions[key] === null){
                this.aboutMeInput.append(optionElement);
            } else {
                optionElement.setAttribute('value', aboutMeOptions[key]);
                this.aboutMeInput.append(optionElement);
            }
        }
        //enable about me field
        this.aboutMeInput.disabled = false;
    }

    updateProgress(){
        //get total percentages of each step
        const stepTwoPercentage = 50;
        const stepThreePercentage = 40;
        const stepFourPercentage = 10;

        //get total checked boxes of each step
        const checkboxesStep02 = document.querySelectorAll('#stepGroup-2 input[type="checkbox"]').length;
        const checkedStep02 = document.querySelectorAll('#stepGroup-2 input[type="checkbox"]:checked').length;
        const checkboxesStep03 = document.querySelectorAll('#stepGroup-3 input[type="checkbox"]').length;
        const checkedStep03 = document.querySelectorAll('#stepGroup-3 input[type="checkbox"]:checked').length;
        const checkboxesStep04 = document.querySelectorAll('#stepGroup-4 input[type="checkbox"]').length;
        const checkedStep04 = document.querySelectorAll('#stepGroup-4 input[type="checkbox"]:checked').length;

        let checkedTwoPercentage = 0;
        let checkedThreePercentage = 0;
        let checkedFourPercentage = 0;

        this.percentageCircle = document.querySelector('.cl-progress .stat.animated .completed');
        this.percentageNumber = document.querySelector('.cl-progress .stat.animated .number');
        this.completedIcon = document.querySelector('.cl-progress .cl-completed');

        if(checkedStep02 == 0){
            checkedTwoPercentage = 0;
        } else {
            checkedTwoPercentage = checkedStep02 / checkboxesStep02;
        }

        if(checkedStep03 == 0){
            checkedThreePercentage = 0;
        } else {
            checkedThreePercentage = checkedStep03 / checkboxesStep03;
        }

        if(checkedStep04 == 0){
            checkedFourPercentage = 0;
        } else {
            checkedFourPercentage = checkedStep04 / checkboxesStep04;
        }

        const totalPercent = Math.round(((checkedTwoPercentage) * stepTwoPercentage) + ((checkedThreePercentage) * stepThreePercentage) + ((checkedFourPercentage) * stepFourPercentage));

        //gotta be a better way to do this (:'
        if(totalPercent === 100){
            this.percentageCircle.style.strokeDashoffset = "2";
            this.percentageNumber.classList.add('deactive');
            this.completedIcon.classList.add('active');
        } else if (totalPercent < 10){
            this.percentageCircle.style.strokeDashoffset = "1.0"+totalPercent;
        }
        else {
            this.percentageCircle.style.strokeDashoffset = "1."+totalPercent;
            this.percentageNumber.classList.remove('deactive');
            this.completedIcon.classList.remove('active');
        }
        this.percentageNumber.textContent = totalPercent + '%';
    }

}

export default Apply;